import { Location } from '@/services/gql/graphql.generated';
import { FC, useState } from 'react';
import { FiMapPin } from 'react-icons/fi';
import { TSTitleCard } from '../../components/shared/card/Card';
import { useHolidayRegionName, useTenantDefaultHolidayRegionLabel } from '../../services/holiday/useHolidayRegions';
import { EditLocationDetailsModal } from './EditLocationDetailsModal';
import strings from './manageLocation.translations';

interface LocationDetailsCardProps {
  location: Location;
}

export const LocationDetailsCard: FC<LocationDetailsCardProps> = ({ location }) => {
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const holidayRegionName = useHolidayRegionName(location.holidayRegionCode);
  const tenantDefaultHolidayRegionLabel = useTenantDefaultHolidayRegionLabel(
    strings.locationHolidayRegion.notSet,
    strings.locationHolidayRegion.inheritOption
  );
  const selectedHolidayRegion = holidayRegionName ?? tenantDefaultHolidayRegionLabel;

  return (
    <>
      <TSTitleCard
        primaryAction={{
          label: strings.editLocationDetails.editLabel,
          onClick: () => setEditModalOpen(true)
        }}
        title={strings.locationDetailsCard.title}
        icon={FiMapPin}
        className="w-full"
      >
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12">
          <div className="flex min-w-0 flex-col">
            <span className="font-semibold">{strings.locationDetailsCard.name}</span>
            <span className="break-words">{location.name}</span>
          </div>
          <div className="flex min-w-0 flex-col">
            <span className="font-semibold">{strings.locationDetailsCard.holidayRegion}</span>
            <span className="break-words">{selectedHolidayRegion}</span>
          </div>
        </div>
      </TSTitleCard>
      <EditLocationDetailsModal open={editModalOpen} onClose={() => setEditModalOpen(false)} location={location} />
    </>
  );
};
